import script from "./UserRecharge.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserRecharge.vue?vue&type=script&setup=true&lang=ts"

import "./UserRecharge.vue?vue&type=style&index=0&id=5556f082&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5556f082"]])

export default __exports__